module.exports = __webpack_public_path__ + "media/images/love_story-eb6fdeb86b2ce7d73281f86a73d31525.svg";